import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0zm-8.99 4a1 1 0 1 1 0 2H12a1 1 0 1 1 0-2h.01zM9.893 6.547A4 4 0 0 1 15.92 10c0 1.53-1.135 2.542-1.945 3.082a8.041 8.041 0 0 1-1.686.849l-.035.012-.011.003a.115.115 0 0 0-.004.002h-.002L11.92 13l.316.949a1 1 0 0 1-.634-1.897h.001l.016-.006.074-.027a6.058 6.058 0 0 0 1.172-.6c.69-.46 1.055-.95 1.055-1.419v-.001a2 2 0 0 0-3.887-.667 1 1 0 0 1-1.887-.664 4 4 0 0 1 1.747-2.121zM23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11z",
		fill: "currentColor"
	})
});
export default SvgHelp;
